import { createBrowserRouter } from 'react-router-dom'
import { Layout, DFMLayout, MortgageLayout } from './components/layout'
import {
  GatewayPage,
  HomePage,
  OverviewPage,
  FeaturesPage,
  PricingPage,
  AboutPage,
  ContactPage,
  DemoPage,
  GetStartedPage,
  BookDemoPage,
  BookInstantStartPage,
  HelpUsBuildPage,
  NotFoundPage,
  JourneyPage,
  JourneyHubPage,
  ComparePage,
  PartnerProgrammePage,
  ValueOfAdvicePage,
  SecurityPage,
  PrivacyPolicyPage,
  TermsPage,
  ResourcesPage,
  BlogIndexPage,
  BlogPostPage,
  PartnerSignupPage,
  PartnerDashboardPage,
  ProjectionMethodologyPage,
  InvestmentManagersPage,
  DFMContactPage,
  MortgageAdvisersPage,
  MortgageContactPage,
} from './pages'

export const router = createBrowserRouter([
  // Gateway page - standalone, no Layout
  { path: '/', element: <GatewayPage /> },

  // DFM section with DFM-specific layout
  {
    element: <DFMLayout />,
    children: [
      { path: '/investment-managers', element: <InvestmentManagersPage /> },
      { path: '/investment-managers/contact', element: <DFMContactPage /> },
    ],
  },

  // Mortgage section with Mortgage-specific layout
  {
    element: <MortgageLayout />,
    children: [
      { path: '/mortgage-advisers', element: <MortgageAdvisersPage /> },
      { path: '/mortgage-advisers/contact', element: <MortgageContactPage /> },
    ],
  },

  // Adviser / main section with standard Layout
  {
    element: <Layout />,
    children: [
      // Adviser homepage (moved from /)
      { path: '/advisers', element: <HomePage /> },

      // Main routes
      { path: '/overview', element: <OverviewPage /> },
      { path: '/features', element: <FeaturesPage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/demo', element: <DemoPage /> },
      { path: '/get-started', element: <GetStartedPage /> },
      { path: '/book-demo', element: <BookDemoPage /> },
      { path: '/book-instant-start', element: <BookInstantStartPage /> },
      { path: '/help-us-build', element: <HelpUsBuildPage /> },

      // Journey routes
      { path: '/journeys', element: <JourneyHubPage /> },
      { path: '/journey/:slug', element: <JourneyPage /> },

      // Comparison routes
      { path: '/compare/:competitor', element: <ComparePage /> },

      { path: '/pricing', element: <PricingPage /> },

      // Legal pages
      { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
      { path: '/terms', element: <TermsPage /> },
      { path: '/security', element: <SecurityPage /> },

      // Resources
      { path: '/resources', element: <ResourcesPage /> },

      // Blog
      { path: '/blog', element: <BlogIndexPage /> },
      { path: '/blog/:slug', element: <BlogPostPage /> },

      // Partner pages
      { path: '/partner-programme', element: <PartnerProgrammePage /> },
      { path: '/partner-signup', element: <PartnerSignupPage /> },
      { path: '/partner-dashboard', element: <PartnerDashboardPage /> },

      // Other pages
      { path: '/value-of-advice', element: <ValueOfAdvicePage /> },
      { path: '/projection-methodology', element: <ProjectionMethodologyPage /> },

      // 404 catch-all
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
